import { Component, Input } from '@angular/core';

@Component({
  selector: 'fgb-mobile-navigation',
  templateUrl: './mobile-navigation.component.html',
  styleUrl: './mobile-navigation.component.scss',
})
export class MobileNavigationComponent {
  @Input() textColor: string;
}
